import {injectable} from "inversify";
import {Component} from "@vue/runtime-core";
import {BaseEntity} from "@/modules/base/entity";

export type LinkComponent = {
  class: new (...args: any[]) => BaseEntity,
  component: Component,
}

@injectable()
export class LinkComponentManager {
  private items: LinkComponent[] = [];

  public addItem(item: LinkComponent) {
    this.items.push(item);
  }

  public getComponent(entity: BaseEntity): Component {
    const item = this.items.find(item => entity instanceof item.class);

    if (!item) {
      throw 'There is not matching component for entity type';
    }

    return item.component;
  }
}